import { BrowserRouter } from 'react-router';

import { AnswerSavesProvider } from '../../contexts/answer-saves';
import { AppearanceSavesProvider } from '../../contexts/appearance-saves';
import { LanguageProvider } from '../../contexts/language';
import { NoteSavesProvider } from '../../contexts/note-saves';
import { SessionProvider } from '../../contexts/session';

import { AccountLifetime } from '../account-lifetime';
import { ApplyAppearance } from '../apply-appearance';
import { Router } from '../router';

// The application's outermost frame: browser routing, the device language,
// who is signed in, and the route table that depends on all three. The
// account's chosen theme is applied beside the routes, for every screen;
// questionnaire answers (#114), a clinician's notes (#132) and the
// appearance (#136) keep their saving state above every screen, the notes
// and the appearance for one signed-in account at a time (#138).
export function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <SessionProvider>
          <AnswerSavesProvider>
            <AccountLifetime>
              <NoteSavesProvider>
                <AppearanceSavesProvider>
                  <ApplyAppearance/>

                  <Router/>
                </AppearanceSavesProvider>
              </NoteSavesProvider>
            </AccountLifetime>
          </AnswerSavesProvider>
        </SessionProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}
